import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Store} from "@ngxs/store";
import {Observable} from "rxjs";
import {GetAccountStatusAction} from "../actions/account.actions";

@Injectable({ providedIn: 'root' })
export class AccountStatusResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store.dispatch(new GetAccountStatusAction())
  }
}
